import * as React from 'react'
import * as s from './MessageLog.scss'
import cn from 'classnames'
import { Message } from '../Message/Message'

export interface IMessageLogProps {
  className?: string
  otherNumber: string
  messages: {
    id: string
    dateSent: string
    from: string
    body: string
  }[]
  onMount?: () => void
}

export class MessageLog extends React.Component<IMessageLogProps> {
  componentDidMount() {
    const { onMount } = this.props
    if (onMount) {
      onMount()
    }
  }
  render() {
    const { className, messages, otherNumber } = this.props
    return (
      <div className={cn(s.outer, className)}>
        {messages.map(message => (
          <Message
            key={message.id}
            time={message.dateSent}
            sender={message.from}
            other={message.from === otherNumber}
          >
            {message.body}
          </Message>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Messages/MessageLog/MessageLog.tsx